import React from 'react';
import { formatEventRange } from '../../../services/storefront';
import { STORE } from '../../storefront/storeInfo';
import { IconArrowUpRight, IconCalendar } from '../../storefront/icons';

// The announcement bar's rotating messages: the next dated trade show, a
// line for the visitor's trade-account state, and the Faire link. Shared by
// TopNav and the admin preview so the two never drift apart. `textKey` and
// `ctaKey` name the editable wording (Admin → Homepage Text) they show.
export const buildAnnouncements = ({ events, tradeState, firstName, copy, onApply }) => {
  const messages = [];
  const nextEvent = events.find((event) => event.dates);
  if (nextEvent) {
    messages.push({
      id: `event-${nextEvent.id}`,
      icon: <IconCalendar size={14} />,
      text: `${nextEvent.title} · ${formatEventRange(nextEvent.dates)}`,
      cta: 'Details',
      to: '/wholesale',
    });
  }
  if (tradeState === 'guest') {
    messages.push({
      id: 'trade-guest',
      text: copy['announce.guest'],
      textKey: 'announce.guest',
      cta: copy['announce.guestCta'],
      ctaKey: 'announce.guestCta',
      onClick: onApply,
    });
  } else if (tradeState === 'pending') {
    messages.push({
      id: 'trade-pending',
      text: copy['announce.pending'],
      textKey: 'announce.pending',
      cta: 'Account',
      to: '/dashboard',
    });
  } else {
    messages.push({
      id: 'trade-active',
      text: firstName ? `Welcome back, ${firstName}` : 'Welcome back',
      cta: 'Shop the catalog',
      to: '/products',
    });
  }
  messages.push({
    id: 'faire',
    text: copy['announce.faire'],
    textKey: 'announce.faire',
    cta: <IconArrowUpRight size={13} />,
    href: STORE.faireUrl,
    external: true,
  });
  return messages;
};
